module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_9005.53563f61.png";